<template>
	<div>
		<breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
    <form class="section" @submit.prevent="selectEDC">
      <div class="field">
        <label class="label">Select Your EDC</label>
        <div class="control">
          <select class="input" v-model="selected_edc">
            <option value=''>All EDC</option>
            <option v-for="(edc_row, index) in list_edc" :key="index" :value="edc_row.id">{{edc_row.edc_number}}</option>
          </select>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="submit" class="button is-link">Select EDC</button>
        </div>
      </div>
    </form>
		<table class="table is-striped is-fullwidth">
			<thead>
				<tr>
					<th>Date Time</th>
					<th>EDC Number</th>
					<th>Type</th>
					<th>Total</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row_data, index) in list_data" :key="index">
					<td>{{ row_data.date_time }}</td>
					<td>{{ row_data.edc_number }}</td>
					<td>{{ row_data.type }}</td>
					<td>{{ row_data.total }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
  data () {
    return {
      list_data: [],
      list_breadcrumbs: [{
        title: 'Giving',
        path: '/panel/giving/'
      }],
      basepath: '/panel/giving/',
      selected_edc: '',
      list_edc: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    var self = this
    self.$geb.emit({id: 'preloader', eventData: true})
    self.flyGetSession('edc')
    .then(function (response) {
      if (response.data.response_code === 1) {
        self.list_edc = response.data.data
      } else {
        var result = response.data.message
        for (var name in response.data.message) {
          self.errors.add(name, result[name])
        }
      }
    })
    .catch(function (response) {
      self.errorMessage(response)
    })
    self.flyPostSession('frontdesk/get_giving', {
      edc: self.selected_edc
    })
    .then(function (response) {
      if (response.data.response_code === 1) {
        self.list_data = response.data.data
      } else if (response.data.response_code === -1) {
        self.removeSessionItem('id_token')
        self.removeSessionItem('access_token')
        self.$router.push('/')
      } else {
        console.log(response.data.message)
      }
      self.$geb.emit({id: 'preloader', eventData: false})
    })
    .catch(function (response) {
      self.errorMessage(response)
      self.$geb.emit({id: 'preloader', eventData: false})
    })
  },
  methods: {
    selectEDC () {
      var self = this
      self.flyPostSession('frontdesk/get_giving', {
        edc: self.selected_edc
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.list_data = response.data.data
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/panel/giving/Home.vue